import { createUseUpdateGap, UpdateGapBaseParams } from './useUpdateGap';

export interface UpdateQualityGapParams extends UpdateGapBaseParams {
    submission_answer?: null | Pick<SubmissionAnswerType, 'metadata'>;
}

export const useUpdateQualityGap = createUseUpdateGap<UpdateQualityGapParams, GapType>({
    urlPrefix: '/api/quality-gaps/',
    gapProp: 'quality_gaps',
});
